<div class="position-relative">
  <div [ngBusy]="{busy: busy, message: ('common.pleaseWait' | translate)}">
    <ng-container *ngIf="countryCode">
      <div class="panel-box">
        <div class="pb-header"
             [translate]="'profile.myAccount.header'">Basic information
        </div>

        <div class="pb-content">
          <form [formGroup]="basicInfoForm" novalidate>
            <div class="form-group form-group-xl"
                 [hidden]="user?.hasCustomerId">
              <label [translate]="'profile.myAccount.email'">E-mail address / username</label>

              <input class="form-control"
                     [formControlName]="'email'"
                     [maxlength]="'128'"
                     [placeholder]="'profile.myAccount.email' | translate"
                     [pattern]="EMAIL_PATTERN">
            </div>

            <div class="form-group form-group-xl">
              <label [translate]="'common.fullName'">First name</label>

              <input class="form-control"
                     [formControlName]="'fullName'"
                     [maxlength]="'128'"
                     [placeholder]="'common.fullName' | translate">
            </div>

            <ui-i18n-phone-input
              *libphonenumber
              name="userPhone"
              [formControlName]="'phone'"
              [maxlength]="'32'"
              [defaultCountryCode]="countryCode"
              [placeholder]="('profile.myAccount.phone' | translate) + '...'"
            ></ui-i18n-phone-input>
            <ui-message class="d-block mt-3 mb-3"
                        *ngIf="updateInfoError"
                        [type]="'error'">{{updateInfoError}}
            </ui-message>

            <div class="text-end mt-4">
              <button class="btn btn-primary pe-5 ps-5"
                      [disabled]="!basicInfoForm.valid || basicInfoForm.pristine"
                      [translate]="'common.save'"
                      (click)="updateUserInfo()">
                Save
              </button>
            </div>
          </form>
        </div>

      </div>

      <reset-password-form
        class="d-block mt-2rem"
        *ngIf="user && !user?.hasCustomerId"
        [user]="user"
      ></reset-password-form>
    </ng-container>
  </div>
</div>
